import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { EXISTING_PROJECT_LIST,CLIENT_LIST, GET_SOLUTION, GET_ALL_QUOTATIONS, GET_QUOTATION, QUOTATION_HISTORY } from "./type";
import {APARTMENT_LEAD} from "../corporate/type";

export const getExistingProjectList = (projectData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    projectData,
    Config.preSalesList.checkProjectExist
  );
  if (res) {
    const { data } = res;
    dispatch({ type: EXISTING_PROJECT_LIST, payload: data.response.data });
    return true;
  }
};

export const getExistingProjectListInEdit = (val) => async (dispatch) => {

  const {
    name,
    isLat,
    isLong,
    societyType,
    projectType,
  } = val;

  const projectData = {
   
    project_name: `${name}`,
    // current_location: `${currentLocation}`,
    lat: `${isLat}`,
    lng: `${isLong}`,
    society_type: societyType,
    project_type: projectType,
  };



  const res = await callWebService(
    callTypes.post,
    projectData,
    Config.preSalesList.checkProjectExist
  );
  if (res) {
    const { data } = res;
    dispatch({ type: EXISTING_PROJECT_LIST, payload: data.response.data });
    return true;
  }
};

export const getSolution = (categoryId=null) => async (dispatch) => {
  let route = Config.brandActivation.getSolution
  if(categoryId!=null){
    route = `${Config.maintenance.fetchMaterials}?categoryId=${categoryId}`
  }
  const res = await callWebService(
    callTypes.get,
    '',
    route
  );
  if (res) {
    const { data } = res;
    if(categoryId!=null){
      return data?.data ?? data?.response?.data;
    }
    const payload = data?.data ?? data?.response?.data ?? null;
    if (payload) {
      dispatch({ type: GET_SOLUTION, payload });
    }
    return true;
  }
}

export const getMaterialPrice = (materialId=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getMaterialPrice}?materialId=${materialId}`
  );
  if (res) {
    const { data } = res;
    if(materialId!=null){
      return data?.data ?? data?.response?.data;
    }
  }
}

export const setQuotation = (data) => async (dispatch) => {
  let route = Config.brandActivation.setQuotation
  if (data?.id) {
    route = `${Config.brandActivation.setQuotation}?quotation_id=${data.id}`
  }
  const res = await callWebService(
    callTypes.post,
    data,
    route
  );
  if (res) {
    const { data } = res;
    return true;
  }
}

export const getAllQuotations = (approve, filterData=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData===null?
      `${Config.brandActivation.getAllQuotations}?approve=${approve}`
    :
    `${Config.brandActivation.getAllQuotations}?approve=${approve}&status=${filterData.status}&created_at=${filterData.created_at}&client_name=${filterData.client_name}&project_id=${filterData.project_id}`
  );
  if (res) {
    const { data } = res;
    const payload = data?.data ?? data?.response?.data ?? null;
    if (payload) {
      dispatch({ type: GET_ALL_QUOTATIONS, payload });
    }
    return true;
  }
}

export const getQuotation = (id, approve) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getQuotation}?id=${id}&approve=${approve}`
  );
  if (res) {
    const { data } = res;
    const payload = data?.data ?? data?.response?.data ?? null;
    if (payload) {
      dispatch({ type: GET_QUOTATION, payload });
    }
    return true;
  }
}

export const quotationStatusChange = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.brandActivation.quotationStatusChange
  );
  if (res) {
    const { data } = res;
    return true;
  }
}

export const quotationHistory= (filterData=null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData===null?
      `${Config.brandActivation.quotationHistory}`
    :
    `${Config.brandActivation.quotationHistory}?status=${filterData.status}&created_at=${filterData.created_at}&client_name=${filterData.client_name}&project_id=${filterData.project_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: QUOTATION_HISTORY, payload: data.response.data });
    return true;
  }
}

/* export const savePresalesSupply = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    Config.preSalesSupply.create
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: CREATE_PRE_SALE_SUPPLY, payload: data.response.data });
    return true;
  }
}; */

export const createProjectOnboarding = (val) => async (dispatch) => {
  const {
    sourceLead,
    alternateChannle,
    mainSource,
    otherSource,
    leadCatId,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    slotsNo,
    gatesNo,
    reservedSlots,
    fcfsSlots,
    address1,
    address2,
    avgChFlat,
    // date,
    flatNo,
    // rwaTenure,
    carsNo,
    HelpStaffNo,
    poc,
    leadSourceOther,
    contact_date,
    interactionTypeLead,
    societyType,
    // gateType,
    vms,
    existingGates,
    occupancy,
    disputeLevel,
    societyUpkeeping,
    amenities,
    managedBy,
    maintainanceCharges,
    securityAgency,
    gates,
    projectType,
    projectSubType,
    products,
    partners,
    marquee_site,
    mailCamp,
    evChargersNo,
    supplyName,
    carSlots,
    bikeSlots,
    otherSlots,
    occupancyCar,
    occupancyBike,
    entryGates,
    exitGates,
    parkingFloors,
    parkingRevenue,
    photos,
    parkingAgency,
    existing_setup,
    fmcName,
    typeSite,
    typeSubSite,
    type_of_ev_charges,
    brand
  } = val;

  const data = {
    lead_source_id: sourceLead,
    alternateChannle: alternateChannle,
    mainSource: mainSource,
    otherSource: otherSource,
    lead_interaction_type_id: interactionTypeLead,
    lead_category_id: leadCatId,
    client_name: `${name}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    tp_poc_site_id: pocVal,
    poc_other_details: `${poc}`,
    other_poc_sites: `${poc}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    no_of_slots: slotsNo,
    no_of_gates: gatesNo,
    reserved_slots: reservedSlots,
    fcfs_slots: fcfsSlots,
    no_of_flats: flatNo,
    no_of_staff: HelpStaffNo,
    no_of_cars: carsNo,
    // rwa_end_date: `${date}`,
    // rwa_tenure: `${rwaTenure}`,
    rwa_maintenance_charge: `${avgChFlat}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    contact_date: `${contact_date}`,
    other_lead_source: `${leadSourceOther}`,
    society_type: societyType,
    // gate_type: gateType,
    vms_type: vms,
    existing_gates: existingGates,
    occupancy: occupancy,
    dispute_level: disputeLevel,
    society_upkeeping: societyUpkeeping,
    amenities: amenities,
    managed_by: managedBy,
    maintainance_charges: maintainanceCharges,
    security_agency: securityAgency,
    gate_details: gates,
    project_type: projectType,
    projectSubType:projectSubType,
    products: products,
    partners: partners,
    marquee_site: marquee_site,
    mail_campaign: mailCamp.value,
    no_of_evchargers: evChargersNo,
    supply_id: supplyName,
    car_slots: `${carSlots}`,
    bike_slots: `${bikeSlots}`,
    other_slots: `${otherSlots}`,
    occup_car: occupancyCar?.id,
    occup_bike: occupancyBike?.id,
    entry_gates: `${entryGates}`,
    exit_gates: `${exitGates}`,
    parking_floors: `${parkingFloors}`,
    parking_rev: `${parkingRevenue}`,
    sec_agency: `${securityAgency}`,
    park_agency: `${parkingAgency}`,
    site_photos: `${photos}`,
    existing_setup: existing_setup,
    fmc_name: `${fmcName}`,
    site_type_id: `${typeSite}`,
    site_sub_type_id: `${typeSubSite}`,
    type_of_ev_charges: `${type_of_ev_charges}`,
    brand: `${brand}`,
  };
  // console.log(data); return false;
  const res = await callWebService(
      callTypes.post,
      data,
      Config.createLead.projectOnboarding
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: APARTMENT_LEAD, payload: data.response.data });
    return true;
  }
};

//Add business new address
export const isAddLocationSuccess = (res) => {
  if (!res) return false;
  if (res?.data?.data === true) return true;
  const legacyStatus = res?.data?.response?.status;
  const legacyData = res?.data?.response?.data;
  return legacyStatus === true && legacyData !== false && res?.data?.data !== false;
};

export const addLocationDetailsData = (location,type,lead_id,clinetId=null,clinetPAN=null,clinetGST=null,registeredName='',contractId=null) => async (dispatch) => {
  const data = {
    'location':location,
    'type':type,
    'lead_id':lead_id,
    'clinet_id': clinetId,
    'clinet_pan': clinetPAN,
    'clinet_gst': clinetGST,
    'registered_name' : registeredName,
    'contractId' : contractId
  }
  const res = await callWebService(
    callTypes.post,
    data,
    Config.businessAndClientLocation.addLocation
  );
  if (res) {
    const { data } = res;
    return res;
  }
}

export const getClientList = (queryObj, page = 1) => async (dispatch) => {
  dispatch({ type: CLIENT_LIST, payload: null });
  let filterQuery = `page=${page}`;
  if(queryObj !== null){
    filterQuery+= `&client_name=${queryObj.client_name}`;
  }

  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.businessAndClientLocation.getClientList}?${filterQuery}`
  );

  if (res) {
    const { data } = res;
    dispatch({ type: CLIENT_LIST, payload: data.response.data });
    return data.response.data;
  }
}; 

// checkGstNumber
export const checkGstNumber = (client_id, gst_number) => async (dispatch) => {
  // dispatch({ type: CLIENT_LIST, payload: null });
  let filterQuery = `client_id=${client_id}&gst_number=${gst_number}`;

  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.businessAndClientLocation.checkGstNumber}?${filterQuery}`
  );

  if (res) {
    const { data } = res;
    // dispatch({ type: CLIENT_LIST, payload: data.response.data });
    return data.response.data;
  }
}; 

//Finance business onboarding
export const financeProjectOnboarding = (val) => async (dispatch) => {
  const {
    sourceLead,
    alternateChannle,
    mainSource,
    otherSource,
    leadCatId,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    slotsNo,
    gatesNo,
    reservedSlots,
    fcfsSlots,
    address1,
    address2,
    avgChFlat,
    // date,
    flatNo,
    // rwaTenure,
    carsNo,
    HelpStaffNo,
    poc,
    leadSourceOther,
    contact_date,
    interactionTypeLead,
    societyType,
    // gateType,
    vms,
    existingGates,
    occupancy,
    disputeLevel,
    societyUpkeeping,
    amenities,
    managedBy,
    maintainanceCharges,
    securityAgency,
    gates,
    projectType,
    projectSubType,
    products,
    partners,
    marquee_site,
    mailCamp,
    evChargersNo,
    supplyName,
    carSlots,
    bikeSlots,
    otherSlots,
    occupancyCar,
    occupancyBike,
    entryGates,
    exitGates,
    parkingFloors,
    parkingRevenue,
    photos,
    parkingAgency,
    existing_setup,
    fmcName,
    typeSite,
    typeSubSite,
    clientData,
    client_gst,
    client_pan,
  } = val;

  const data = {
    lead_source_id: sourceLead,
    alternateChannle: alternateChannle,
    mainSource: mainSource,
    otherSource: otherSource,
    lead_interaction_type_id: interactionTypeLead,
    lead_category_id: leadCatId,
    client_name: `${name}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    tp_poc_site_id: pocVal,
    poc_other_details: `${poc}`,
    other_poc_sites: `${poc}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    no_of_slots: slotsNo,
    no_of_gates: gatesNo,
    reserved_slots: reservedSlots,
    fcfs_slots: fcfsSlots,
    no_of_flats: flatNo,
    no_of_staff: HelpStaffNo,
    no_of_cars: carsNo,
    // rwa_end_date: `${date}`,
    // rwa_tenure: `${rwaTenure}`,
    rwa_maintenance_charge: `${avgChFlat}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    contact_date: `${contact_date}`,
    other_lead_source: `${leadSourceOther}`,
    society_type: societyType,
    // gate_type: gateType,
    vms_type: vms,
    existing_gates: existingGates,
    occupancy: occupancy,
    dispute_level: disputeLevel,
    society_upkeeping: societyUpkeeping,
    amenities: amenities,
    managed_by: managedBy,
    maintainance_charges: maintainanceCharges,
    security_agency: securityAgency,
    gate_details: gates,
    project_type: projectType,
    projectSubType:projectSubType,
    products: products,
    partners: partners,
    marquee_site: marquee_site,
    mail_campaign: mailCamp.value,
    no_of_evchargers: evChargersNo,
    supply_id: supplyName,
    car_slots: `${carSlots}`,
    bike_slots: `${bikeSlots}`,
    other_slots: `${otherSlots}`,
    occup_car: occupancyCar?.id,
    occup_bike: occupancyBike?.id,
    entry_gates: `${entryGates}`,
    exit_gates: `${exitGates}`,
    parking_floors: `${parkingFloors}`,
    parking_rev: `${parkingRevenue}`,
    sec_agency: `${securityAgency}`,
    park_agency: `${parkingAgency}`,
    site_photos: `${photos}`,
    existing_setup: existing_setup,
    fmc_name: `${fmcName}`,
    site_type_id: `${typeSite}`,
    site_sub_type_id: `${typeSubSite}`,
    client_data: clientData,
    client_gst: `${client_gst}`,
    client_pan: `${client_pan}`,
  };
  //console.log('999' + data); //return false;
  const res = await callWebService(
      callTypes.post,
      data,
      Config.createLead.financeProjectOnboarding
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: APARTMENT_LEAD, payload: data.response.data });
    return true;
  }
};


export const updateProjectOnboarding = (val) => async (dispatch) => {
  const {
    sourceLead,
    alternateChannle,
    mainSource,
    otherSource,
    leadCatId,
    name,
    currentLocation,
    email,
    secondContact,
    islocationType,
    pocVal,
    pocName,
    pocDesVal,
    number,
    isLat,
    isLong,
    area,
    zone,
    city,
    geoStateId,
    geoCityId,
    pinId,
    slotsNo,
    gatesNo,
    reservedSlots,
    fcfsSlots,
    address1,
    address2,
    avgChFlat,
    // date,
    flatNo,
    // rwaTenure,
    carsNo,
    HelpStaffNo,
    poc,
    leadSourceOther,
    contact_date,
    interactionTypeLead,
    societyType,
    // gateType,
    vms,
    existingGates,
    occupancy,
    disputeLevel,
    societyUpkeeping,
    amenities,
    managedBy,
    maintainanceCharges,
    securityAgency,
    gates,
    projectType,
    products,
    partners,
    marquee_site,
    mailCamp,
    evChargersNo,
    supplyName,
    carSlots,
    bikeSlots,
    otherSlots,
    occupancyCar,
    occupancyBike,
    entryGates,
    exitGates,
    parkingFloors,
    parkingRevenue,
    photos,
    parkingAgency,
    leadId,
    existing_setup,
    fmcName,
    typeSite,
    typeSubSite,
  } = val;

  const data = {
    lead_id:leadId,
    lead_source_id: sourceLead,
    lead_type:projectType,
    alternateChannle: alternateChannle,
    mainSource: mainSource,
    otherSource: otherSource,
    lead_interaction_type_id: interactionTypeLead,
    lead_category_id: leadCatId,
    client_name: `${name}`,
    current_location: `${currentLocation}`,
    location_type: islocationType,
    tp_poc_site_id: pocVal,
    poc_other_details: `${poc}`,
    other_poc_sites: `${poc}`,
    poc_name: `${pocName}`,
    poc_designation: `${pocDesVal}`,
    poc_phone_number: `${number}`,
    poc_email: `${email}`,
    poc_secondary_contact: `${secondContact}`,
    latitude: `${isLat}`,
    longitude: `${isLong}`,
    area_id: area,
    zone_id: zone,
    city_id: city,
    geo_state: geoStateId,
    geo_city: geoCityId,
    geo_pincode: pinId,
    no_of_slots: slotsNo,
    no_of_gates: gatesNo,
    reserved_slots: reservedSlots,
    fcfs_slots: fcfsSlots,
    no_of_flats: flatNo,
    no_of_staff: HelpStaffNo,
    no_of_cars: carsNo,
    // rwa_end_date: `${date}`,
    // rwa_tenure: `${rwaTenure}`,
    rwa_maintenance_charge: `${avgChFlat}`,
    address_line_one: `${address1}`,
    address_line_two: `${address2}`,
    contact_date: `${contact_date}`,
    other_lead_source: `${leadSourceOther}`,
    society_type: societyType,
    // gate_type: gateType,
    vms_type: vms,
    existing_gates: existingGates,
    occupancy: occupancy,
    dispute_level: disputeLevel,
    society_upkeeping: societyUpkeeping,
    amenities: amenities,
    managed_by: managedBy,
    maintainance_charges: maintainanceCharges,
    security_agency: securityAgency,
    gate_details: gates,
    project_type: projectType,
    products: products,
    partners: partners,
    marquee_site: marquee_site,
    mail_campaign: mailCamp.value,
    no_of_evchargers: evChargersNo,
    supply_id: supplyName,
    car_slots: `${carSlots}`,
    bike_slots: `${bikeSlots}`,
    other_slots: `${otherSlots}`,
    occup_car: occupancyCar?.id,
    occup_bike: occupancyBike?.id,
    entry_gates: `${entryGates}`,
    exit_gates: `${exitGates}`,
    parking_floors: `${parkingFloors}`,
    parking_rev: `${parkingRevenue}`,
    sec_agency: `${securityAgency}`,
    park_agency: `${parkingAgency}`,
    site_photos: `${photos}`,
    existing_setup: existing_setup,
    fmc_name: `${fmcName}`,
    site_type_id: `${typeSite}`,
    site_sub_type_id: `${typeSubSite}`,
  };
  // console.log(data); return false; 
  const res = await callWebService(
      callTypes.post,
      data,
      Config.createLead.updateprojectOnboarding
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({ type: APARTMENT_LEAD, payload: data.response.data });
    return true;
  }
};